import React from 'react'

export default function jobReducer() {
  return (
    <div>jobReducer</div>
  )
}
